/**
 * Generado por scripts/scaffold-module.ts el 2026-07-23.
 * Rutas del módulo ItemsFacturables.
 *
 * Este archivo es auto-cargado por src/router/routes.ts via import.meta.glob.
 * NO necesitas registrarlo manualmente en ningún otro sitio.
 */
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/items-facturables',
    name: 'items_facturables.index',
    component: () => import('./views/ItemsFacturablesIndex.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true,
      requiresPermission: 'items_facturables.read',
      title: 'Items_facturables',
    },
  },
]

export default routes
